import React from 'react';

import { mdiNewspaper } from '@lumapps/lumx/icons';
import { NavigationItemType } from '@lumapps/navigation/types';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { NAVIGATION_ADMIN } from '../../keys';
import { NavigationItemWizardOptionProps } from '../../types';
import { ContentWizardOption } from './ContentWizardOption';

export const ArticleWizardOption: React.FC<NavigationItemWizardOptionProps> = (props) => {
    const { translateKey } = useTranslate();

    return (
        <ContentWizardOption
            {...props}
            name={translateKey(GLOBAL.ARTICLE)}
            description={translateKey(NAVIGATION_ADMIN.PICK_ARTICLE_DESCRIPTION)}
            pageType={NavigationItemType.ARTICLE}
            pickerType={NavigationItemType.ARTICLE}
            id="article"
            icon={mdiNewspaper}
        />
    );
};
